export default __webpack_public_path__ + "static/media/home-shop-modern-06.7af8c7d0.png";